/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MessageBannerCarousel_messages$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageBanner_user$ref: FragmentReference;
export type MessageBanner_user = {|
  +registeredUserMessages: ?$ReadOnlyArray<?{|
    +$fragmentRefs: MessageBannerCarousel_messages$ref
  |}>,
  +$refType: MessageBanner_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "MessageBanner_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "registeredUserMessages",
      "name": "bannerMessages",
      "storageKey": null,
      "args": null,
      "concreteType": "MessageSetModule",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "MessageBannerCarousel_messages",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e027c1ac5554a6a7800dcb2707fe399a';
module.exports = node;
